import { css } from "@emotion/react";
import { BodyMedium14, BodyMedium16Css, H7, H7Css } from "../Typography";
import IconBox from "../UI/IconBox";
import { mq } from "@/constants/breakpoints";

type Benefit = {
  label: string;
  details: string;
  icon: { url: string };
};
interface BenefitsProps {
  benefits: Benefit[];
}

const BenefitsCard: React.FC<BenefitsProps> = ({ benefits }) => {
  return (
    <div
      css={css`
        margin: 60px auto;
        padding: 24px;
        ${mq["sm"]} {
          padding: 30px 24px;
        }
        ${mq["md"]} {
          padding: 40px;
        }
        ${mq["xl"]} {
          padding: 40px 44px;
        }
        background: linear-gradient(
          103.92deg,
          rgba(255, 255, 255, 0.1) -0.74%,
          rgba(190, 220, 255, 0.1) 99.87%
        );
        border: 1px solid rgba(255, 255, 255, 0.1);
        backdrop-filter: blur(40px);
        border-radius: 15px;
        max-width: 577px;
      `}
    >
      {benefits.map((benefit, index) => (
        <div
          key={index}
          css={css`
            margin-top: ${index > 0 ? "20px" : "0px"};
          `}
        >
          <Benefit
            icon={
              <img
                src={benefit.icon.url}
                alt="Website Icon"
                style={{ color: "white" }}
              />
            }
            title={benefit.label}
            desc={benefit.details}
          />
        </div>
      ))}
    </div>
  );
};

function Benefit({ icon, title, desc }: any) {
  return (
    <div
      css={css`
        display: flex;
        flex-direction: row;
        gap: 20px;
        color: white;
        ${mq["lg"]} {
          gap: 30px;
        }
        ${mq["xl"]} {
          gap: 30px;
        }
      `}
    >
      <div
        css={css`
          display: flex;
          align-items: center;
          justify-content: center;
        `}
      >
        <IconBox>{icon}</IconBox>
      </div>
      <div
        css={css`
          display: flex;
          flex-direction: column;
          justify-content: center;
        `}
      >
        <H7
          css={css`
            font-size: 18px;
            font-weight: 400;
            line-height: 23.4px;
            color: white;
            ${mq["lg"]} {
              ${H7Css}
            }
          `}
        >
          {title}
        </H7>
        <BodyMedium14
          css={css`
            display: none;
            ${mq["sm"]} {
              display: block;
              margin-top: 4px;
              font-size: 14px;
            }
            ${mq["xl"]} {
              ${BodyMedium16Css}
            }
          `}
        >
          {desc}
        </BodyMedium14>
      </div>
    </div>
  );
}

export default BenefitsCard;
